import React from 'react'
import { DonutChart } from '@/components/DonutChart'

interface Goal {
  id: string
  name: string
  value: number
  percentage: number
  color: string
  description: string
  isScale?: boolean
}

interface GoalsGridProps {
  goals: Goal[]
}

export function GoalsGrid({ goals }: GoalsGridProps) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
      {goals.map((goal) => (
        <div key={goal.id} className="card-hover group text-center animate-fade-in-up">
          <h3 className="font-display text-xl font-semibold text-white mb-6 group-hover:text-brand-primary transition-colors duration-200">{goal.name}</h3>
          <div className="flex flex-col items-center justify-center">
            <div className="group-hover:scale-105 transition-transform duration-200">
              <DonutChart 
                percentage={goal.percentage} 
                color={goal.color} 
                size={120}
                displayValue={goal.isScale ? `${goal.value}/5` : `${goal.value}`}
              />
            </div>
            <p className="text-sm text-brand-gray-light font-body mt-4 max-w-xs leading-relaxed">{goal.description}</p>
          </div>
        </div>
      ))}
    </div>
  )
}